import { hideContent } from './showMore';

let btnOpen = $('.show-filter-btn');
let btnClose = $('.close-filter-btn');
let form = $('.form-filter');
let body = $('body');

export function openFilter() {
  btnOpen.on('click', function (event) {
    event.preventDefault();

    form.addClass('open');
    body.addClass('menu-open');
    hideContent();
  });
}

export function closeFilter() {
  btnClose.on('click', function (event) {
    event.preventDefault();

    form.removeClass('open');
    body.removeClass('menu-open');
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/asideFilter.js